import { render, staticRenderFns } from "./Service20Table.vue?vue&type=template&id=7f355b0e&"
import script from "./Service20Table.vue?vue&type=script&lang=js&"
export * from "./Service20Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports